<template>
    <div class="d-flex justify-content-between py-3 header-container ">
        <div>
            <div class="d-flex gap-2 align-items-center">
                <img src="../../../assets/images/title-icon.png" alt="">
                <h3>{{competition.name}}</h3>
            </div>
        </div>
    </div>    
    <div class="main-edit-container">
        <div class="template-details-container">
            <p class="template-name">
                <span class="template-header">Descriptive Template : </span>{{templateName}} &nbsp;&nbsp;
            </p>
            <router-link :to="'/templates/view/'+template_id_view" v-if="permissions.includes('viewAny template')" class="linkViewTemplate">
                View Template
            </router-link>
        </div>
        <div class="btnOrganization">
        </div>
    

        <div id="createUserContainer" class="tabcontent1">
            <div class="firstStartDate" v-if="competition.start_date != null">
                <h6>Start Date</h6>
                <p>{{competition.start_date}}</p>
            </div>
            <div class="firstStartDate" v-else>
                <h6>Start Date</h6>
                <p>Not Choosen</p>
            </div>

            <div class="secondEndDate" v-if="competition.end_date != null">
                <h6>End Date</h6>
                <p>{{competition.end_date}}</p>
            </div>
            <div class="secondEndDate" v-else>
                <h6>End Date</h6>
                <p>Not Choosen</p>
            </div>

            <div class="startTimeCss" v-if="competition.start_time != null">
                <h6>Start Time</h6>
                <p>{{competition.start_time}} GMT</p>
            </div>
            <div class="startTimeCss" v-else>
                <h6>End Time</h6>
                <p>Not Choosen</p>
            </div>

            <div class="startTimeCss" v-if="competition.end_time != null">
                <h6>End Time</h6>
                <p>{{competition.end_time}} GMT</p>
            </div>
            <div class="startTimeCss" v-else>
                <h6>End Time</h6>
                <p>Not Choosen</p>
            </div>

            <div class="durationCss" v-if="competition.duration != null">
                <h6>Duration</h6>
                <p>{{competition.duration}} minutes</p>
            </div>
            <div class="durationCss" v-else>
                <h6>Duration</h6>
                <p>{{durationInTime}} minutes</p>
            </div>
            <!-- I found it commented, please keep it commented don't use your brain -->
            <!-- <div class="cssActionsStyle">
               <font-awesome-icon  :icon="['fas', 'trash']" class="trashDesign" v-if="permissions.includes('delete competition')" @click.prevent="deleteCompetition"  size="xl"/>
                &nbsp;&nbsp;&nbsp;&nbsp;
               <font-awesome-icon :icon="['fas', 'pen']" class="penDesign" size="xl" @click.prevent="EditCompetition"/>
            </div> -->
        </div>

        <div  v-if="usersAssignedData.length > 0" class="assigned-user-container">
            <div class="d-flex justify-content-between mb-4">
                <div v-if="competition.participant_type === 'individual'">
                    <h3>Users</h3>
                </div>
                <div v-else>
                    <h3>Team</h3>
                </div>
                <div class="btnOrganization2">
                    <button @click.prevent="AssignUserToCompetition">Assign</button>
                </div>
            </div>

            <div class="row d-flex styleFlex">
                <div class="col-md-2 styleCssAssigned" v-for="user in usersAssignedData" :key="user.id">
                    <div class="styleUser">
                        {{user.participant.name}}
                    </div>
                    <div class="styleTrash">
                        <font-awesome-icon  :icon="['fas', 'trash']" class="trash" @click.prevent="deleteUser(user.id)"  size="lg"/>
                    </div>
                </div>
            </div>
        </div>

        <div id="createUserContainer2" class="d-flex justify-content-center" v-else>
            <div class="assignUsersCss">
                <div class="text-center mb-4">
                    <img src="../../../assets/images/surface1.svg" alt="" >
                </div>
                <div class="text-center mb-4">
                    <h5>No Users or Teams Are Assigned for This Competitions</h5>
                </div>
                <div class="buttonCssAssign text-center">
                    <button @click="AssignUserToCompetition">Assign To User Or Team</button>
                </div>
            </div>
        </div>
    </div>
    <router-link class="back-route" ref="backBtn" @click="backHandler" :to="isFull ? '#':'/competitions'">
                    <button class="back-btn">Back</button>
    </router-link>
    <AssignUsers @clickAssign="clickAssignHandler" v-if="this.isShow" :training_type="training_type" :participant="participant_type_data" :message="confirmMessage" :confirmUsers="ChooseUsers" :confirmTeam="ChooseTeam"
                    @close-modal="this.isShow = false"
                    :confirmTeamLeader="ChooseTeamLeader"/>

    <ModalChooseUser @close-modal="closeModalHandler" v-if="this.isAssignFlag" :training_type="training_type" :participant="participant_type_data" :message="chooseMessageText" :data="data" @assignUsers1="AssignUsers1" @assignUsers2="AssignUsers2"/>

    <AssignTeamLeader v-if="isShow2" @close-modal="this.isShow2 = false"  @success="ShowModalSuccess" :whoPlay="whoPlay" :training_type="training_type" :participant="participant_type_data" :message="confirmMessage" :confirmUsers="ChooseUsers" :confirmTeam="ChooseTeam" />

    <ConfirmationModal v-if="confirmModalFlag2" :message="confirmMessage" confirmBtn="Delete" cancleBtn="Cancel"
                        @close-modal="confirmModalHandler($event)"/>

    <ConfirmationModal v-if="confirmModalFlag3" :message="confirmMessage2" :id="competition_user_id" confirmBtn="Delete" cancleBtn="Cancel"
                        @close-modal="confirmModalHandler2($event)"/>

    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>
</template>

<script>
    import AssignUsers from '../../components/AssignUsers';
    import AssignTeamLeader from '../../components/AssignTeamLeader';
    import ModalChooseUser from '../../components/ModalChooseUsers';
    import competition from "../../../api-services/competition";
    import ConfirmationModal from "../../components/ConfirmationModal";
    import AlartModal from "../../components/AlartModal";
    import {computed} from "vue";
    import moment from "moment";

    export default {
        name:'complete-edit-competition',
        props:['ChooseUsers' , 'ChooseTeam' , 'ChooseTeamLeader' , 'AssignUsers' , 'success'],
        data(){
            return {
                isFull:false,
                isShow:false,
                isShow2:false,
                showModal:false,
                permissions:[],
                message:'',
                ImagePath:'',
                isAssignFlag: false,
                confirmModalFlag: false,
                confirmModalFlag2: false,
                confirmModalFlag3: false,
                competition_user_id:null,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{

                },
                competition:{
                    name:null,
                    template_id:null,
                    participant_type:null,
                    type:1,
                    start_date:null,
                    end_date:null,
                    start_time:null,
                    end_time:null,
                    duration:null
                },
                data: [],
                durationInTime:null,
                templateName:'',
                usersAssignedData:[],
                template_id_view:null,
                confirmMessage: '',
                confirmMessage2: '',
                chooseMessageText:'',
                participant_type_data:null,
                training_type:null,
                whoPlay:null
            }
        },
        components:{
            AssignUsers,
            ModalChooseUser,
            ConfirmationModal,
            AssignTeamLeader,
            AlartModal
        },
       async mounted(){
            this.getCompetition();
            this.getUsersAssigned();
            this.permissions = this.$store.state.auth.permissions;
            const compData = await competition.show(this.$route.params.id);
           this.participant_type_data = compData.data.data.participant_type;
           this.whoPlay = compData.data.data.is_play;
        },
        methods:{
            ShowModalSuccess(){
                const competition_id = this.$route.params.id;
                this.isShow2 = false;
                this.showModal = true;
                this.ImagePath = 'okImage.svg';
                this.message = "Users Assigned Successfully";
                window.location.href="/complete-edit-competitions/"+competition_id;
            },
            clickAssignHandler(event){
                this.isAssignFlag = true;
                this.data = event[1].data.data;
                this.chooseMessageText = event[0];
            },
            AssignUsers1(){
                const competition_id = this.$route.params.id;
                this.isAssignFlag = false;
                this.isShow = false;
                this.showModal = true;
                this.ImagePath = 'okImage.svg';
                this.message = "Users Assigned Successfully";
                window.location.href = "/complete-edit-competitions/"+competition_id;
            },

            AssignUsers2(){
                const competition_id = this.$route.params.id;
                this.isAssignFlag = false;
                this.isShow = false;
                this.isShow2 = true;
            },

            closeModalHandler(e){
                this.isShow = false;
                this.isAssignFlag = false
            },

            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            async confirmModalHandler (event) {
                // await this.$store.dispatch('setConfirmModal', false);
                this.confirmModalFlag2 = false;
                if(event){
                    const competition_id = this.$route.params.id;
                    await competition.delete(competition_id);
                    // await this.$store.dispatch('setDataFlag', false);
                    this.confirmModalFlag2 = false;
                    await this.$router.push('/competitions');
                }
            },
            async confirmModalHandler2 (event) {
                this.confirmModalFlag3 = false;
                if(event){
                    const competition_id = this.$route.params.id;
                    await competition.deleteUserAssigned(this.competition_user_id);

                    this.confirmModalFlag3 = false;
                    // await this.$router.push('/complete-edit-competitions/'+competition_id);
                    window.location.href = '/complete-edit-competitions/'+competition_id;
                }
            },
            AssignUserToCompetition(){
                this.isShow = true;
                this.confirmModalFlag = true;
                this.confirmMessage = 'Assign to';
            },
            async getCompetition(){
                const competition_id = this.$route.params.id;
                try{
                    const response = await competition.show(competition_id);

                    this.competition.name = response.data.data.name.charAt(0).toUpperCase() +  response.data.data.name.slice(1);
                    this.competition.template_id = response.data.data.template_id;
                    this.competition.start_date = moment(response.data.data.start_date).format('D-MMM-YYYY');
                    this.competition.participant_type = response.data.data.participant_type;
                    this.competition.end_date = moment(response.data.data.end_date).format('D-MMM-YYYY');
                    this.competition.start_time = response.data.data.start_time.slice(0,5);
                    this.competition.end_time = response.data.data.end_time.slice(0,5);
                    this.competition.duration = response.data.data.duration;
                    this.templateName = response.data.data.template.name;

                    if(this.competition.duration === null){
                        let startTime = moment(this.competition.start_time, "HH:mm:ss a");
                        let endTime = moment(this.competition.end_time, "HH:mm:ss a");
                        let duration  = moment.duration(endTime.diff(startTime));
                        let hours = parseInt(duration.asHours()) * 60;
                        let minutes = parseInt(duration.asMinutes()) % 60;

                        this.durationInTime = (hours+minutes);
                    }

                    this.template_id_view = response.data.data.template.id;
                }catch(e) {
                    console.log(e);
                }
            },
            async getUsersAssigned(){
                const competition_id = this.$route.params.id;
                try{
                    const response = await competition.getUsersAssigned(competition_id);
                    console.log(response.data.data);
                    this.usersAssignedData = response.data.data;
                }catch(e){
                    console.log(e);
                }
            },
            deleteCompetition(){
                this.confirmModalFlag2 = true;
                this.confirmMessage = 'D you want to delete this competition?';
            },
            EditCompetition(){
                const competition_id = this.$route.params.id;
                this.$router.push({path: "/edit-competitions/"+competition_id});
            },
            deleteUser(e){
                try{
                    this.competition_user_id = e;
                    this.confirmModalFlag3 = true;
                    this.confirmMessage2 = 'Do you want to delete this user?';
                }catch(error){
                    console.log(error);
                }
            },
            async SaveCompetition(){
                try{
                    const competition_id = this.$route.params.id;

                    if(this.competition.start_time === null && this.competition.end_time === null){
                        this.competition.date_type = 2;
                    }else{
                        this.competition.date_type = 1;
                    }
                    const response = await competition.update(competition_id , {
                        name:this.competition.name,
                        template_id:this.template_id_view,
                        type:1,
                        date_type:this.competition.date_type,
                        start_date:this.competition.start_date,
                        end_date:this.competition.end_date,
                        start_time:this.competition.start_time,
                        end_time:this.competition.end_time,
                        duration:this.competition.duration,
                    });

                    this.$router.push({path: "/competitions"});
                }catch(e){
                    console.log(e);
                }
            }
        }
    }
</script>

<style scoped>
    .header-container{
        padding-inline: 30px;
    }
    h3{
        margin: 0;
        text-transform: uppercase;
    }
    .back-route{
        margin-top: 2vh;
        display: flex;
        justify-content: end;
        width:100%;
        height: 35px;
        padding-inline: 30px;
    }
    .back-btn{
        background-color: #707070 !important;
        padding: 0px 50px;
        text-decoration: none;
        cursor: pointer;
        color: #FFF;
        font-size: 18px;
        border: 0;
        border-radius: 5px;
    }
    .main-edit-container{
        margin-inline: 30px;
        background-color: #022B3C;
        padding: 30px;
        border-radius: 5px;
        height: 63vh;
        overflow-y: auto;
    }
    .assigned-user-container{
        padding: 30px;
        background-color: #023144;
        border: 1px solid rgba(200, 200, 200,0.1);
        border-radius: 10px;
    }
    .template-details-container{
        margin-bottom:20px;
    }
    .template-name{
        font-size: 18px;
        padding: 0;
    }
    .template-header{
        color:#37A6A2;
        font-size: 18px;
        font-weight: 600;
    }
    .styleInIPad{
        margin-bottom: 3rem;
    }
    .styleTrash{
        position:absolute;
    }
    .trash{
        position: relative;
        top:12px;
        left: 260px;
        color: #FF7171;
        cursor: pointer;
    }
    .styleUser{
        display: flex;
        align-items: center;
        padding-left: 10px;
    }
    .styleFlex{
        gap:50px;
    }
    .styleCssAssigned{
        position: relative;
        display: flex;
        border: 1px solid #39525C;
        width: 300px;
        height: 50px;
        border-radius: 6px;
    }
    .btnOrganization2 button {
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: none;
        border-radius: 5px;
        justify-content: end;
        /*align-content: center;*/
        width: 140px;
        padding: 10px;
    }
    .tabcontent1 div h6{
        font-size: 1.5rem !important;
    }
    .tabcontent1 div p{
        font-size: 1rem !important;
    }

    .btnOrganization button {
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: none;
        border-radius: 5px;
        justify-content: end;
        align-content: center;
        padding: 10px;
    }

    .buttonCssAssign button{
        border:none;
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        padding: 10px 70px;
        border-radius: 5px;
    }
    .penDesign {
        color: #00970A;
        cursor: pointer;
    }
    .trashDesign {
        color: #FF7171;
        cursor: pointer;
    }
    .cssActionsStyle{
        width: 370px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .secondEndDate,
    .firstStartDate,
    .startTimeCss,
    .durationCss{
        width:auto;
    }
    .linkViewTemplate{
        color:#e65c00;
    }
    .assignUsersCss{
        width:100%;
        padding: 30px;
        height: auto;
        background-color: #023144;
        border: 1px solid rgba(200, 200, 200,0.1);
        border-radius: 15px;
    }
    .tabcontent1{
        display: flex;
        justify-content: space-between;
        align-items: center !important;
        padding: 20px;
        height: 15vh;
        background-color: #023144;
        border: 1px solid rgba(200, 200, 200,0.1);
        border-radius: 10px;
        margin-bottom: 10px;
    }

    @media(max-width:1280px){
        .tabcontent1 div h6{
            font-size: 1.2rem !important;
        }
    }
</style>